import React from 'react';
import { useNavigate } from 'react-router';
import {
  Gutter,
  Layout,
  ContextMenuItem,
  CondensedLabel,
  CondensedMedium,
  DateUtil,
} from '@axiom/ui';
import type { Notification, User } from '@axiom/validation';

import { NotificationsApi } from '../../api/notifications-api';

import { NotificationIndicator } from './NotificationsItemStyles';

export type NotificationsItemProps = {
  notification: Notification;
  user: User;
  name?: string;
};

export const NotificationsItem = ({
  notification,
  user,
  name = 'NOTIFICATIONS_ITEM',
}: NotificationsItemProps) => {
  const navigate = useNavigate();

  let notificationBody = notification.body;
  let notificationLink = null;

  try {
    const jsonNotification = JSON.parse(notification.body ?? '');
    notificationBody = jsonNotification?.content;
    notificationLink = jsonNotification?.link;

    if (notificationLink?.startsWith('http')) {
      notificationLink = notificationLink.slice(notificationLink.indexOf('//'));
    }
  } catch {
    /* empty */
  }

  const handleClick = async () => {
    if (!notification.isRead) {
      await NotificationsApi.updateNotification(notification.id, {
        isRead: true,
      });
      await NotificationsApi.refreshNotifications(user.id);
    }

    if (notificationLink) {
      void navigate(notificationLink);
    }
  };

  return (
    <ContextMenuItem
      onClick={async () => {
        await handleClick();
      }}
      name={name}
    >
      <Layout position="middle">
        <NotificationIndicator
          className={notification.isRead ? 'read' : undefined}
          data-test="NOTIFICATIONS_ITEM_IS_READ_MARKER"
        />

        <CondensedLabel name="NOTIFICATIONS_ITEM_TITLE">
          {notification.subject}
        </CondensedLabel>
      </Layout>
      {notificationBody ? (
        <Gutter left="16px" top="8px">
          <CondensedMedium name="NOTIFICATIONS_ITEM_CONTENT">
            {notificationBody}
          </CondensedMedium>
        </Gutter>
      ) : null}
      <Gutter left="16px" top="8px">
        <CondensedMedium name="NOTIFICATIONS_ITEM_DATE">
          {DateUtil.displayShortDate(notification.createdAt)}
        </CondensedMedium>
      </Gutter>
    </ContextMenuItem>
  );
};
